/**
 * Chain labels and block explorer URLs — env-driven chain ids, not Sepolia-only copy.
 */

export const ETHEREUM_MAINNET_CHAIN_ID = 1;
export const SEPOLIA_CHAIN_ID = 11155111;

/** @param {number|string|null|undefined} chainId */
export function getChainLabel(chainId) {
  const n = Number(chainId);
  if (!Number.isFinite(n)) return "configured network";
  if (n === ETHEREUM_MAINNET_CHAIN_ID) return "Ethereum Mainnet";
  if (n === SEPOLIA_CHAIN_ID) return "Ethereum Sepolia";
  return `chain ${n}`;
}

/** @param {number|string|null|undefined} chainId */
export function getTxExplorerBaseUrl(chainId) {
  const n = Number(chainId);
  if (n === ETHEREUM_MAINNET_CHAIN_ID) return "https://etherscan.io";
  if (n === SEPOLIA_CHAIN_ID) return "https://sepolia.etherscan.io";
  if (n === 5) return "https://goerli.etherscan.io";
  return null;
}

/** @param {number|string|null|undefined} chainId @param {string} txHash */
export function getTxExplorerUrl(chainId, txHash) {
  const h = String(txHash || "").trim();
  if (!/^0x[a-fA-F0-9]{64}$/.test(h)) return null;
  const base = getTxExplorerBaseUrl(chainId);
  if (!base) return null;
  return `${base}/tx/${h}`;
}

/** @param {number|string|null|undefined} chainId @param {string} contract @param {string|number} tokenId */
export function getNftExplorerUrl(chainId, contract, tokenId) {
  const c = String(contract || "").trim();
  const t = String(tokenId ?? "").trim();
  if (!c || !t) return null;
  const base = getTxExplorerBaseUrl(chainId);
  if (!base) return null;
  return `${base}/nft/${c}/${t}`;
}

/** @param {number|string|null|undefined} chainId */
export function getSwitchToNetworkLabel(chainId) {
  return `Switch to ${getChainLabel(chainId)}`;
}

/** @param {number|string|null|undefined} chainId */
export function getWrongNetworkMessage(chainId) {
  return `Wrong network. ${getSwitchToNetworkLabel(chainId)} to continue.`;
}

const DEFAULT_MAINNET_RPC = "https://eth.llamarpc.com";
const DEFAULT_SEPOLIA_RPC = "https://ethereum-sepolia-rpc.publicnode.com";

/**
 * Read-only JSON-RPC URL for a chain (public defaults when env omits overrides).
 * @param {number} chainId
 */
export function getChainRpcUrl(chainId) {
  const n = Number(chainId);
  if (n === ETHEREUM_MAINNET_CHAIN_ID) {
    return (
      String(process.env.REACT_APP_MAINNET_RPC_URL || "").trim() || DEFAULT_MAINNET_RPC
    );
  }
  if (n === SEPOLIA_CHAIN_ID) {
    return (
      String(process.env.REACT_APP_SEPOLIA_RPC_URL || "").trim() || DEFAULT_SEPOLIA_RPC
    );
  }
  throw new Error(`No default RPC for chain ${n}. Set REACT_APP_TRDX_RPC_URL or chain-specific RPC env.`);
}
